
export const FICHA_OBRA_PRINT_STYLES = `
.fo-doc {
  --fo-ink: #23292f;
  --fo-muted: #5b6670;
  --fo-rule: #d6dbe0;
  --fo-panel: #f3f5f7;
  --fo-brand: #da6c00;
  --fo-brand-soft: #fdf0e3;

  color: var(--fo-ink);
  font-family: 'Hiragino-W4', 'Open Sans', 'Noto Sans', Arial, sans-serif;
  font-size: 8.5pt;
  line-height: 1.4;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.fo-doc *, .fo-doc *::before, .fo-doc *::after { box-sizing: border-box; }

.fo-doc h1, .fo-doc h2, .fo-doc h3, .fo-doc p, .fo-doc dl, .fo-doc dd, .fo-doc ul, .fo-doc ol { margin: 0; }

.fo-doc .fo-ficha { break-after: page; }
.fo-doc .fo-ficha:last-child { break-after: auto; }

.fo-doc .fo-head {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 5mm;
  padding: 3mm 4mm;
  border: 0.6pt solid var(--fo-rule);
  border-top: 1.1mm solid var(--fo-brand);
  border-radius: 3px;
  margin-bottom: 2.5mm;
  break-inside: avoid;
}

.fo-doc .fo-brand { display: block; font-size: 7pt; font-weight: 700; color: var(--fo-brand); margin-bottom: 1mm; }
.fo-doc .fo-title-row { display: flex; align-items: baseline; gap: 2mm; flex-wrap: nowrap; margin-bottom: 0.8mm; }
.fo-doc .fo-head h1 { font-size: 11pt; line-height: 1.2; font-weight: 700; color: var(--fo-ink); }
.fo-doc .fo-address { color: var(--fo-muted); font-size: 8pt; }

.fo-doc .fo-head-id {
  min-width: 30mm;
  padding-left: 4mm;
  border-left: 0.6pt solid var(--fo-rule);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1mm;
}

.fo-doc .fo-id { font-size: 11pt; font-weight: 700; line-height: 1.1; }
.fo-doc .fo-tags-head { display: flex; flex-wrap: wrap; gap: 1mm; flex-shrink: 0; }
.fo-doc .fo-module, .fo-doc .fo-worktype { padding: 0.4mm 1.8mm; font-size: 7pt; font-weight: 600; border-radius: 2px; }
.fo-doc .fo-module { background: var(--fo-brand-soft); color: var(--fo-brand); }
.fo-doc .fo-worktype { background: var(--fo-panel); color: var(--fo-ink); }

.fo-doc .fo-summary {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.8mm;
  margin-bottom: 4mm;
  break-inside: avoid;
}

.fo-doc .fo-cell { padding: 1.6mm 2.6mm 1.9mm; background: var(--fo-panel); border-radius: 3px; min-width: 0; }
.fo-doc .fo-label { display: block; font-size: 6.5pt; color: var(--fo-muted); margin-bottom: 0.4mm; }
.fo-doc .fo-value { font-size: 8.5pt; font-weight: 600; overflow-wrap: anywhere; }
.fo-doc .fo-value.fo-empty { font-weight: 400; color: var(--fo-muted); }
.fo-doc .fo-stars { color: var(--fo-brand); letter-spacing: 0.8pt; }
.fo-doc .fo-stars .fo-off { color: #c3cad1; }

.fo-doc .fo-section { border: 0.6pt solid var(--fo-rule); border-radius: 3px; margin-bottom: 3.5mm; }

.fo-doc .fo-section h2 {
  display: flex;
  align-items: center;
  gap: 2mm;
  padding: 1.6mm 3.2mm;
  background: var(--fo-panel);
  border-bottom: 0.6pt solid var(--fo-rule);
  font-size: 9pt;
  font-weight: 700;
  break-after: avoid;
}

.fo-doc .fo-section h2::before {
  content: "";
  width: 1mm;
  height: 3.2mm;
  background: var(--fo-brand);
  border-radius: 1px;
}

.fo-doc .fo-section h2 small { margin-left: auto; font-size: 7pt; font-weight: 400; color: var(--fo-muted); }
.fo-doc .fo-body { padding: 2.5mm 3.2mm 3mm; display: flex; flex-direction: column; gap: 2.5mm; }

.fo-doc .fo-numbers { display: grid; grid-template-columns: repeat(5, 1fr); gap: 1.5mm; break-inside: avoid; }
.fo-doc .fo-numbers > div { padding: 1.3mm 2.2mm; border: 0.6pt solid var(--fo-rule); border-radius: 2px; min-width: 0; }
.fo-doc .fo-numbers dt { font-size: 6.5pt; color: var(--fo-muted); font-weight: 400; }
.fo-doc .fo-numbers dd { font-size: 8.5pt; font-weight: 600; overflow-wrap: anywhere; }

.fo-doc .fo-subgroup { padding: 2mm 2.8mm; background: var(--fo-panel); border-radius: 2px; break-inside: avoid; }
.fo-doc .fo-subgroup h3 { margin-bottom: 1mm; font-size: 7.5pt; color: var(--fo-muted); font-weight: 600; }
.fo-doc .fo-units-grid { display: grid; width: 100%; align-items: center; }
.fo-doc .fo-units-head { font-size: 6.5pt; color: var(--fo-muted); text-transform: uppercase; font-weight: 700; text-align: center; padding: 0 1.5mm 1mm; border-bottom: 0.3mm solid #cfd4d9; }
.fo-doc .fo-units-cell { text-align: center; padding: 1mm 1.5mm; border-bottom: 0.2mm solid #e3e6e9; white-space: nowrap; }
.fo-doc .fo-units-cell.fo-unit-name { flex: none; text-align: left; padding-left: 0; }
.fo-doc .fo-units { padding: 0; list-style: none; }
.fo-doc .fo-units li { display: flex; flex-wrap: wrap; align-items: baseline; column-gap: 3mm; row-gap: 0.6mm; }
.fo-doc .fo-units li + li { margin-top: 1.8mm; }
.fo-doc .fo-unit-name { flex: 0 0 24mm; font-size: 7pt; color: inherit; text-transform: uppercase; font-weight: 700; }
.fo-doc .fo-unit-info { display: inline-flex; align-items: baseline; gap: 1mm; white-space: nowrap; }
.fo-doc .fo-unit-label { font-size: 6.5pt; color: var(--fo-muted); text-transform: uppercase; font-weight: 700; }
.fo-doc .fo-unit-value { font-size: 8.5pt; color: #E8740A; font-weight: 700; }
.fo-doc .fo-tags { display: flex; flex-wrap: wrap; gap: 1.2mm; }
.fo-doc .fo-tag { padding: 0.3mm 1.6mm; border: 0.6pt solid var(--fo-rule); border-radius: 2px; font-size: 7.5pt; background: #fff; }

.fo-doc .fo-company { border: 0.6pt solid var(--fo-rule); border-radius: 2px; break-inside: avoid; }

.fo-doc .fo-company-head {
  display: flex;
  justify-content: space-between;
  gap: 4mm;
  padding: 1.8mm 2.8mm;
  border-bottom: 0.6pt solid var(--fo-rule);
}

.fo-doc .fo-company-head strong { display: block; font-size: 8.5pt; }
.fo-doc .fo-company-meta { font-size: 7.5pt; color: var(--fo-muted); }
.fo-doc .fo-company-phones { text-align: right; font-size: 7.5pt; white-space: nowrap; }
.fo-doc .fo-contacts { display: grid; grid-template-columns: 1fr 1fr; gap: 1.5mm; padding: 1.8mm 2.8mm 2.2mm; }
.fo-doc .fo-no-contacts { padding: 1.8mm 2.8mm 2.2mm; color: var(--fo-muted); font-size: 7.5pt; }

.fo-doc .fo-contact {
  padding: 1.4mm 2.2mm 1.6mm;
  background: var(--fo-panel);
  border-radius: 2px;
  font-size: 7.5pt;
  min-width: 0;
  overflow-wrap: anywhere;
  break-inside: avoid;
}

.fo-doc .fo-contact strong { font-size: 8pt; }
.fo-doc .fo-role { display: inline-block; margin-left: 1.2mm; color: var(--fo-brand); font-size: 7pt; font-weight: 600; }
.fo-doc .fo-line { display: block; color: var(--fo-muted); }

.fo-doc .fo-details > div {
  display: grid;
  grid-template-columns: 24mm 1fr;
  gap: 3mm;
  padding: 1.5mm 0;
  border-bottom: 0.6pt solid var(--fo-rule);
  break-inside: avoid;
}

.fo-doc .fo-details > div:first-child { padding-top: 0; }
.fo-doc .fo-details > div:last-child { border-bottom: none; padding-bottom: 0; }
.fo-doc .fo-details dt { color: var(--fo-muted); font-size: 7.5pt; font-weight: 400; }
.fo-doc .fo-details dd { white-space: pre-line; }

.fo-doc .fo-timeline { padding: 0; list-style: none; }
.fo-doc .fo-timeline li { position: relative; padding: 0 0 2.2mm 6mm; break-inside: avoid; }
.fo-doc .fo-timeline li:last-child { padding-bottom: 0; }

.fo-doc .fo-timeline li::before {
  content: "";
  position: absolute;
  left: 1mm;
  top: 1.4mm;
  width: 1.8mm;
  height: 1.8mm;
  border-radius: 50%;
  background: var(--fo-brand);
}

.fo-doc .fo-timeline li::after {
  content: "";
  position: absolute;
  left: 1.8mm;
  top: 3.8mm;
  bottom: 0;
  width: 0.35mm;
  background: var(--fo-rule);
}

.fo-doc .fo-timeline li:last-child::after { display: none; }
.fo-doc .fo-timeline time { display: block; font-size: 7pt; font-weight: 700; color: var(--fo-brand); }
.fo-doc .fo-timeline strong { display: block; }
`;